/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CmsHomepageBannerFormatEnumType = "BURN_IN" | "CAPTION" | "%future added value";
export type HpRespPromoModulePromoItem_promotion = {
    readonly imageCopy: string | null;
    readonly imageUrl?: string | null;
    readonly imageHeight?: string | null;
    readonly imageWidth?: string | null;
    readonly mobileImageUrl?: string | null;
    readonly mobileImageHeight?: string | null;
    readonly mobileImageWidth?: string | null;
    readonly cta: string | null;
    readonly linkData: {
        readonly path: string | null;
        readonly " $fragmentRefs": FragmentRefs<"HpRespModuleItemTile_linkData" | "HpRespHeroBannerText_linkData" | "SeoLink_linkData">;
    };
    readonly isFullBleedImage: boolean | null;
    readonly title: string | null;
    readonly description: string | null;
    readonly format: CmsHomepageBannerFormatEnumType | null;
    readonly " $fragmentRefs": FragmentRefs<"HpRespSharedHeroBanner_promoItem">;
    readonly " $refType": "HpRespPromoModulePromoItem_promotion";
};
export type HpRespPromoModulePromoItem_promotion$data = HpRespPromoModulePromoItem_promotion;
export type HpRespPromoModulePromoItem_promotion$key = {
    readonly " $data"?: HpRespPromoModulePromoItem_promotion$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespPromoModulePromoItem_promotion">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespPromoModulePromoItem_promotion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageCopy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cta",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpRespModuleItemTile_linkData"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpRespHeroBannerText_linkData"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFullBleedImage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "format",
      "storageKey": null
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageWidth",
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileImageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileImageHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileImageWidth",
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpRespSharedHeroBanner_promoItem"
    }
  ],
  "type": "PromoItem",
  "abstractKey": null
};
(node as any).hash = '4e3d1ca619a82baa983dcda4590a393f';
export default node;
